/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import { getNextgenSettingsUrl } from '@jira/project-settings__get-settings-url/src/getClassicIssueLayoutSettingsUrl.tsx';
import { SERVICE_DESK_PROJECT } from '@jira/platform__project-types/src/project-types.tsx';
import { Redirect, type RouteContext } from '@atlassian/react-resource-router';

type NotificationsUrlFragments = 'customer-notifications';

export const notificationsRedirect =
	(pageUrlFragment: NotificationsUrlFragments) =>
	({ match }: RouteContext): React.JSX.Element => {
		const { projectKey } = match.params;

		const url =
			projectKey !== null && projectKey !== undefined
				? `${getNextgenSettingsUrl(
						SERVICE_DESK_PROJECT,
						projectKey,
					)}/notifications/${pageUrlFragment}`
				: `/projects/${String(projectKey)}/settings/notifications/${pageUrlFragment}`;

		return <Redirect to={url} push={false} />;
	};
